module.exports = __webpack_public_path__ + "assets/img/website-logo_106.6988363e.jpg";